"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSendEmailOptions = void 0;
const validation_1 = require("../validator/validation");
exports.isSendEmailOptions = (0, validation_1.isObjectOf)({
    sender: validation_1.isEmail,
    recipient: (0, validation_1.isArrayOf)(validation_1.isEmail).which((0, validation_1.satisfiesCondition)(a => a.length > 0)),
    cc: (0, validation_1.isSomeOf)((0, validation_1.isArrayOf)(validation_1.isEmail), validation_1.isUndefined, validation_1.isNull),
    bcc: (0, validation_1.isSomeOf)((0, validation_1.isArrayOf)(validation_1.isEmail), validation_1.isUndefined, validation_1.isNull),
    templateName: validation_1.isString,
    templateData: validation_1.isString,
});
//# sourceMappingURL=SendEmailOptions.js.map